import { AssistanceService } from "@/service/services/Assistance.service";
import { ChargeService } from "@/service/services/Charge.service";
import { CostCenterService } from "@/service/services/CostCenter.service";
import { departmentService } from "@/service/services/Deparment.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalDepartamentResponsabilityDelete.type";

export const ModalDepartamentResponsabilityDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, responsability, onListResponsability,areaSelected, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await departmentService.deleteResponsibilities(responsability.id).then((data) => {
            areaSelected && onListResponsability(areaSelected.id);
            clearState && clearState();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
    return (
        <>
        <Modal
        open={open}
        handleClose={closeModal}
        size="xs"
        >
        <ModalHeader
            text="ELIMINAR FUNCIÓN"
            className='positionElements'
            onCancel={closeModal}
            clearState={clearState}
        >
        </ModalHeader>

        <ModalBody>
            <Typography variant="subtitle1" className="textColor"> 
            ¿Está seguro de eliminar esta función del Departamento?
            </Typography>
        </ModalBody>

        <ModalFooter 
            confirmText="Eliminar"
            cancelText="CANCELAR"
            onCancel={closeModal}
            className="footerRight"
            onConfirm={onDeleted}
            clearState={clearState}
        />
        </Modal>
        </>
    )
}